import { useMemo } from "react"
import { Typography, Accordion, AccordionDetails, Grid } from "@mui/material"

import SelectAddress from "components/Quotes/SelectFields/SelectAddress"
import AccordionSummarySlim from "components/Common/AccordionSummarySlim"

import { useTranslations } from "@fenetech/translations";
import { IQuotePermissions } from "helpers/interfaces";
import { useFormContext } from "react-hook-form";
import SelectIsAddressSameAsShipping from "../SelectFields/SelectIsAddressSameAsShipping";

interface IProps {
    expanded : boolean,
    permissions? : IQuotePermissions,
    onExpandedChange : (event: React.SyntheticEvent, expanded: boolean) => void,      
}

function Billing({ expanded, permissions, onExpandedChange } : IProps) {

    const tm = useTranslations();
    const { watch } = useFormContext();
    const watchSameAsShipping = watch("billing.isAddressSameAsShipping");

    const isAddressReadOnly = useMemo(() => {

        if ((permissions?.billingAddress ?? false) === false)
        {
            return true;
        }
        else if ((watchSameAsShipping) === true) {
            return true;
        }

        return false;
    }, [permissions, watchSameAsShipping]);

    return <>

        <Accordion expanded={expanded} onChange={onExpandedChange} disableGutters sx={{ width: 1 }} >
            <AccordionSummarySlim>
                <Typography color="secondary.contrastText">
                    {tm.Get("Billing Address")}
                </Typography>
            </AccordionSummarySlim>
            <AccordionDetails>
                <Grid container spacing={2} padding={0}>
                    <Grid item xs={12} sm={6}>
                        <SelectIsAddressSameAsShipping permissions={permissions} />
                    </Grid>
                    <Grid item xs={12}>
                        <SelectAddress 
                            addressPrefix="billing"
                            readOnly={isAddressReadOnly}
                            hideAllFields={watchSameAsShipping}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>

    </>
}

export default Billing;